import i18n from '@/plugins/i18n'

export const reports=[
    {
        value: '1',
        text: i18n.t('aging_summary_report'),
        permission: 'housingreservationpayment_agingsummaryreport'
    },
    {
        value: '2',
        text: i18n.t('Availability - Tenant Information Report'),
        permission: 'housingtenant_informationreport'
    },
    {
        value: '3',
        text: i18n.t('Work Order/Maintenance Request Report'),
        permission: 'housingtenant_informationreport'
    },
    {
        value: '4',
        text: i18n.t('bank_reconciliation'),
        permission: 'housingreservationpayment_bankreconciliationreport'
    },
    {
        value: '5',
        text: i18n.t('cash_flow_report'),
        permission: 'housingreservationpayment_cashflowreport'
    },
    {
        value: '6',
        text: i18n.t('collection_report'),
        permission: 'housingreservationpayment_collectionreport'
    },
]

